/* i18n */
import { FormattedMessage } from 'react-intl';

/* Styles */
import styles from 'styles/layout.module.scss';
import cn from 'classnames';

/* Assets */
import { logoFooterUrl, organizationName } from 'styles/vars.module.scss';

/* Material UI and other UI Dependencies */
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import { Link } from 'react-router-dom';

function Footer({ children }) {
  return(
    <div className={styles.footer}>
      <div className={styles.colorsBar}>
        <div className={cn(styles.colorsBar__red, styles.colorsBar__color)}></div>
        <div className={cn(styles.colorsBar__green, styles.colorsBar__color)}></div>
        <div className={cn(styles.colorsBar__orange, styles.colorsBar__color)}></div>
        <div className={cn(styles.colorsBar__blue, styles.colorsBar__color)}></div>
      </div>
      <Container maxWidth="lg">
        <Grid container className={styles.footerContent} spacing={0}>
          <Grid item xs={12} sm={6}>
            <div className={styles.footerImages}>
              <img className={styles.footerLogo} src={logoFooterUrl.slice(1, -1)} alt={organizationName} />
            </div>
            <div className={cn(styles.footerText, styles.officialText)}>
              <FormattedMessage id="layout.footer.officialWebsite" />
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className={styles.footerText}>
              <FormattedMessage id="layout.footer.feedbackText" />
              <a className={styles.footerLink} href="mailto:support@backtoworkri.com"><FormattedMessage id="layout.footer.feedbackLink" /></a>
            </div>
            <div className={styles.footerText}>
              <Link className={styles.footerLink} to={'/terms-of-use'}>
                <FormattedMessage id="layout.footer.privacy" />
              </Link>
            </div>
            <div className={styles.footerText}>
              <Link className={styles.footerLink} to={'/credits-and-citations'}>
                <FormattedMessage id="layout.footer.credits" />
              </Link>
            </div>
          </Grid>
        </Grid>
      </Container>
      <hr className={styles.separator} />
      <Container maxWidth="lg">
        <div className={styles.footerCopy}>
          <FormattedMessage id="layout.footer.copy" />
        </div>
      </Container>
    </div>
  )
}

export default Footer;